import React, { Component } from "react";

import {
  CButton,
  CSpinner,
  CModal,
  CModalFooter,
  CModalBody,
  CModalHeader
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import URL from "../../config/api";
import axios from "../../config/axios";
import Dropzone from "../Dropzone";

import "react-bootstrap-table/dist//react-bootstrap-table-all.min.css";

class UploadModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // name: "",
      // description: "",
      loading: true,
      // selectedRoles: "Todos",
      files: [],
      // roles: [],
      // docs: [],
      upload: null
    };
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  upload() {
    if (this.state.files.length < 1) {
      return;
    }

    this.setState({ loading: true });

    const formData = new FormData();

    for (let i = 0; i < this.state.files.length; i++) {
      formData.append(`file${i}`, this.state.files[i]);
    }

    axios
      .post(
        `${URL.api}file/uploads-students/${this.props.user.user.id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${this.props.user.token}`
          }
        }
      )
      .then(
        resp => {
          const len = resp.data.files.length;
          const arr = [];
          resp.data.files.forEach((file, index) => {
            axios
              .post(
                `${URL.api}content/upload_user/insert`,
                {
                  upload_id: this.props.upload_id,
                  name: file.original,
                  user_id: this.props.user.user.id,
                  size: file.size,
                  link: URL.public + file.url,
                  item_id: index === 0 && this.props.item_id,
                  execution_id: index === 0 && this.props.execution_id
                },
                {
                  headers: { Authorization: `Bearer ${this.props.user.token}` }
                }
              )
              .then(
                resp => {
                  arr.push(resp.data.data);

                  if (arr.length === len) {
                    this.setState({ loading: false });
                    this.props.onClose();
                  }
                },
                error => {
                  this.error("Erro ao fazer upload!");
                }
              );
          });
        },
        error => {
          this.error("Erro ao fazer upload!");
        }
      );
  }

  onDrop(files) {
    this.setState({ files });
  }

  async componentDidMount() {
    const res = await axios.get(
      `${URL.api}content/upload/singleView/${this.props.upload_id}`,
      { headers: { Authorization: `Bearer ${this.props.user.token}` } }
    );

    this.setState({ upload: res.data.data, loading: false });
  }

  render() {
    return (
      <CModal
        size="md"
        centered
        show
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          {this.props.readOnly ? "Upload do aluno" : "Upload de arquivos"}
        </CModalHeader>
        {this.state.loading ? (
          <div className="p-4 d-flex align-items-center justify-content-center">
            <CSpinner size="sm" color="secondary"></CSpinner>
          </div>
        ) : (
          <>
            <CModalBody>
              <div className="mb-3">
                <strong>Descrição</strong>
                <div>{this.state.upload.description}</div>
              </div>
              {/* readOnly é para quem não entrega: o professor conferindo a
                  vaga na criação/visualização da atividade. Ali não existe
                  execution_id, então um envio geraria linha solta em
                  content/upload_user. */}
              {this.props.readOnly ? (
                <small className="form-text text-muted">
                  O aluno enviará o arquivo dele ao abrir a atividade.
                </small>
              ) : (
                <Dropzone onDrop={e => this.onDrop(e)} />
              )}
            </CModalBody>
            <CModalFooter className="d-flex justify-content-end">
              <div className="d-flex">
                {!this.props.readOnly && (
                  <CButton
                    disabled={this.state.loading}
                    color="primary"
                    className="d-flex justify-content-center align-items-center mr-2"
                    onClick={() => this.upload()}
                  >
                    <span className={this.state.loading ? "invisible" : ""}>
                      Salvar
                    </span>
                    {this.state.loading && (
                      <CSpinner
                        size="sm"
                        color="white"
                        style={{ position: "absolute" }}
                      />
                    )}
                  </CButton>
                )}{" "}
                <CButton
                  disabled={this.state.loading}
                  color="secondary"
                  onClick={() => this.props.onClose()}
                >
                  {this.props.readOnly ? "Fechar" : "Cancelar"}
                </CButton>
              </div>
            </CModalFooter>
          </>
        )}
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadModal);
